import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { passwordGenerator } from './PasswordGenerator';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface BaseInput {
  name: string;
  value: string;
  label: string;
  placeholder?: string;
  autoGeneratePassword?: boolean;
  onAutoGenerationPasswordFired?: (generatedString: string) => void;
  onChange: (value: { value: string; name: string }) => void;
}

export default function Password<T extends BaseInput>({ autoGeneratePassword, onAutoGenerationPasswordFired, ...props }: T): JSX.Element {
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();
  const handleClickShowPassword = () => setShowPassword(show => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleOnChange = ({ target }) => {
    props.onChange({ name: target.name, value: target.value });
  };

  const generateNewPassword = () => {
    const password = passwordGenerator();
    if (onAutoGenerationPasswordFired) onAutoGenerationPasswordFired(password);
    props.onChange({ name: props.name, value: password });
  };

  return (
    <OutlinedInput
      {...props}
      onChange={handleOnChange}
      type={showPassword ? 'text' : 'password'}
      endAdornment={
        <InputAdornment position="end">
          {autoGeneratePassword && <Button onClick={generateNewPassword} children={<Typography sx={{ fontSize: '14px' }} children={t('Generate')} />} />}
          <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
            {showPassword ? <VisibilityOff sx={{ fontSize: '18px' }} /> : <Visibility sx={{ fontSize: '18px' }} />}
          </IconButton>
        </InputAdornment>
      }
    />
  );
}
